import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Button, Spinner, Form } from 'react-bootstrap';
import ListItems from './ListItems';

import { CONFIG } from '../utils/config';

const ListingDisplay = () => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = async () => {

    const response = await fetch(`${CONFIG.API_URL}${CONFIG.NEWS_PATH}`);
    const allData = await response.json();

    setListings(allData);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [loading]);

  if (loading) {
    return (
      <Container>
        <Row>
          <Col className="p-4">
            <div className="w-100">
              <Spinner animation="border" />
            </div>
          </Col>
        </Row>
      </Container>
    );
  }

  return <Container>{listings && <ListItems data={listings} />}</Container>;
};

export default ListingDisplay;
